// FullStory - commented out: import { type SnippetOptions, init as initFullStory } from '@fullstory/browser';
import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import SpinnerComponent from './components/spinner/spinner.component';
import { setupInterceptors } from './interceptors/setup-interceptors';
import { setupQueryClient } from './query-client/query-client';
import reportWebVitals from './reportWebVitals';
import router from './routes/router';
import './index.scss';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
setupInterceptors();
// FullStory - commented out
// const fullstoryConfig: SnippetOptions = {
//   orgId: `${process.env.REACT_APP_FULLSTORY_ORDID}`,
//   devMode:
//     `${process.env.REACT_APP_FULLSTORY_DEVMODE}`.toLowerCase() === 'true'
//       ? true
//       : false,
// };

// FullStory - commented out: initFullStory(fullstoryConfig);

root.render(
  <StrictMode>
    <QueryClientProvider client={setupQueryClient()}>
      <Suspense fallback={<SpinnerComponent />}>
        <RouterProvider router={router} />
      </Suspense>
    </QueryClientProvider>
  </StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
